/**
 *  Keywords state module file
**/

export const state = {
  childrenMap: {}, // Map<KeywordKey, KeywordItem[]>
  selectedMap: {} // Map<KeywordKey, boolean>
}
